import {
    UAN_LOADING,
    UAN_SUCCESS,
    UAN_FAILED,
    FETCH_UAN_LOADING,
    FETCH_UAN_SUCCESS,
    FETCH_UAN_FAILED,
    ACCEPT_UAN_LOADING,
    ACCEPT_UAN_SUCCESS,
    ACCEPT_UAN_FAILED,
    UPLOAD_SALARY_LOADING,
    UPLOAD_SALARY_SUCCESS,
    UPLOAD_SALARY_FAILED,
    REMOVE_FILE_LOADING,
    REMOVE_FILE_SUCCESS,
    REMOVE_FILE_FAILED,
    UPDATE_UAN_LOADING,
    UPDATE_UAN_SUCCESS,
    UPDATE_UAN_FAILED,
    SAVE_UAN_LOADING,
    SAVE_UAN_SUCCESS,
    SAVE_UAN_FAILED,
    FETCH_GAP_LOADING,
    FETCH_GAP_SUCCESS,
    FETCH_GAP_FAILED,
    GAP_REASON_LOADING,
    GAP_REASON_SUCCESS,
    GAP_REASON_FAILED,
  } from "../Constants/instantUanConstants";
  
  export const uanReducer = (
    state = { uanData: [] },
    action
  ) => {
    switch (action.type) {
      case UAN_LOADING:
        return { loading: true, uanData: [] };
      case UAN_SUCCESS:
        return { loading: false, uanData: action.payload };
      case UAN_FAILED:
        return { loading: false, error: action.uanData };
      default:
        return state;
    }
  };

  export const fetchUanReducer = (
    state = { fetchUanData: [] },
    action
  ) => {
    switch (action.type) {
      case FETCH_UAN_LOADING:
        return { loading: true, fetchUanData: [] };
      case FETCH_UAN_SUCCESS:
        return { loading: false, fetchUanData: action.payload };
      case FETCH_UAN_FAILED:
        return { loading: false, error: action.fetchUanData };
      default:
        return state;
    }
  };

  export const acceptUanReducer = (
    state = { acceptUanData: [] },
    action
  ) => {
    switch (action.type) {
      case ACCEPT_UAN_LOADING:
        return { loading: true, acceptUanData: [] };
      case ACCEPT_UAN_SUCCESS:
        return { loading: false, acceptUanData: action.payload };
      case ACCEPT_UAN_FAILED:
        return { loading: false, error: action.acceptUanData };
      default:
        return state;
    }
  };

  export const uploadSalaryReducer = (
    state = { uploadSalaryData: [] },
    action
  ) => {
    switch (action.type) {
      case UPLOAD_SALARY_LOADING:
        return { loading: true, uploadSalaryData: [] };
      case UPLOAD_SALARY_SUCCESS:
        return { loading: false, uploadSalaryData: action.payload };
      case UPLOAD_SALARY_FAILED:
        return { loading: false, error: action.uploadSalaryData };
      default:
        return state;
    }
  };

  export const removeSalaryReducer = (
    state = { uploadSalaryData: [] },
    action
  ) => {
    switch (action.type) {
      case REMOVE_FILE_LOADING:
        return { loading: true, removeSalaryData: [] };
      case REMOVE_FILE_SUCCESS:
        return { loading: false, removeSalaryData: action.payload };
      case REMOVE_FILE_FAILED:
        return { loading: false, error: action.removeSalaryData };
      default:
        return state;
    }
  };

  export const updateUanReducer = (
    state = { updateUanData: [] },
    action
  ) => {
    switch (action.type) {
      case UPDATE_UAN_LOADING:
        return { loading: true, updateUanData: [] };
      case UPDATE_UAN_SUCCESS:
        return { loading: false, updateUanData: action.payload };
      case UPDATE_UAN_FAILED:
        return { loading: false, error: action.updateUanData };
      default:
        return state;
    }
  };

  export const saveUanReducer = (
    state = { saveUanData: [] },
    action
  ) => {
    switch (action.type) {
      case SAVE_UAN_LOADING:
        return { loading: true, saveUanData: [] };
      case SAVE_UAN_SUCCESS:
        return { loading: false, saveUanData: action.payload };
      case SAVE_UAN_FAILED:
        return { loading: false, error: action.saveUanData };
      default:
        return state;
    }
  };

  export const fetchGapReducer = (
    state = { fetchGapData: [] },
    action
  ) => {
    switch (action.type) {
      case FETCH_GAP_LOADING:
        return { loading: true, fetchGapData: [] };
      case FETCH_GAP_SUCCESS:
        return { loading: false, fetchGapData: action.payload };
      case FETCH_GAP_FAILED:
        return { loading: false, error: action.fetchGapData };
      default:
        return state;
    }
  };

  export const saveGapReasonReducer = (
    state = { saveGapReasonData: [] },
    action
  ) => {
    switch (action.type) {
      case GAP_REASON_LOADING:
        return { loading: true, saveGapReasonData: [] };
      case GAP_REASON_SUCCESS:
        return { loading: false, saveGapReasonData: action.payload };
      case GAP_REASON_FAILED:
        return { loading: false, error: action.saveGapReasonData };
      default:
        return state;
    }
  };